import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import api from './modules/api'
import app from './modules/app'
import tagsView from './modules/tagsView'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
	user:user,
	tagsView:tagsView,
	app:app,
	api:api,
  },
  getters:getters
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js